import { createComponent } from '@carvana/merch-components';

export const Card = createComponent('div', {
  className:
    'border border-grey-2 border-solid flex flex-col gap-16 p-24 rounded-md text-blue-6'
});

export const BodyWrapper = createComponent('div', {
  className: 'self-center text-body-m'
});

export const Dot = createComponent('div', {
  className: 'bg-green-2 h-8 rounded-full w-8'
});

export const FinanceInfoWrapper = createComponent('div', {
  className: 'flex gap-8 items-center text-[14px]'
});

export const Bold = createComponent('span', { className: 'font-bold' });
